/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {


    export interface IInnerExpressionScope extends ng.IScope {
        expression: Wars.Domain.Model.Conditions.Expression;
    }

    export class InnerExpressionGroup implements IDirective {
        public link($scope: any, element: JQuery, attrs: ng.IAttributes) {

        }

        public templateUrl = './app/views/directives/innerExpressionGroup.html';
        public controller = [
            '$scope', 'fieldService', 'formStepService', 'treeService', 'treeItemService', 'conditionService',
            'statusAndStateService','processConfigurationService', InnerExpressionController
        ];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            expression: "=",
            isReadonly: "=",
            processConfigurationId: "="
        };
    }

    export class InnerExpressionModel {
        private contextWithOnlyAnyAndAll: any = {
            includeSpecifiedOptionsOnly: [6, 7]
        };
        public valueAggregateFunctionContext: any = {};
        public fieldAggregateFunctionContext: any = {};
        public statusGroup: Wars.Domain.Model.Statuses.StatusCodeGroup;
        public states:Wars.Domain.Model.Statuses.StateCode[] = [];
        public subTypes:Wars.Domain.Model.ProcessSubType[];

        constructor(
            public expression: Wars.Domain.Model.Conditions.Expression,
            public isReadonly,
            private fieldService: services.FieldService,
            private FormStepService: services.FormStepService,
            private treeService: services.TreeService,
            private treeItemService: services.TreeItemService,
            private conditionService: services.ConditionService,
            private statusGroupService: services.StatusAndStateService,
            private processConfigurationId: string,
            private processConfigurationService:services.ProcessConfigurationService) {

            this.processConfigurationService.getPermitSubTypeInfo(processConfigurationId).then(
                (processConfiguration: Wars.Domain.Model.ProcessConfiguration) => {
                    this.subTypes = processConfiguration.mySubTypeConfiguration.myProcessSubTypes;
                });

            statusGroupService.getStatusAndStatesByProcessConfig(this.processConfigurationId)
                .then(r => {
                    this.statusGroup =r;
                    r.myStatuses.forEach(s => {
                        s.myStates.forEach(state => {
                            this.states.push(state);
                        });
                    });
                });

            var expressionType = this.getType(this.expression);


            if ((<any>expression).valueAggregateFunction) {
                (<any>expression).isValueFieldList = true;
            }

            if ((<any>expression).aggregateFunction) {
                (<any>expression).isFieldList = true;
            }

            if (expressionType === "TreeItemToTreeItemExpression") {
                this.loadTreeItemVariables();
                treeItemService.getTreeItem((<Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression>this.expression)
                        .valueTreeItem_id)
                    .then(ti => {
                        (<Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression>this.expression).valueTreeItem = ti;
                    });
            } else if (expressionType === "TreeItemToConstantExpression") {
                this.loadTreeItemVariables();
            }
        }

        private loadTreeItemVariables() {
            this.treeItemService
                .getTreeItem((<Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression>this.expression).treeItem_id)
                .then(ti => {
                    (<Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression>this.expression).treeItem = ti;
                });

            if ((<Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression>this.expression)
                .treeItemOperationParameterSet_id) {
                this.conditionService
                    .getOperationSetExpanded((<Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression>this.expression
                        )
                        .treeItemOperationParameterSet_id)
                    .then(operationSet => {
                        // (<Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression>this.expression).treeItemOperationParameterSet = operationSet;
                    });
            }
        }

        public getType(obj: Object) {
            var funcNameRegex = /function (.{1,})\(/;
            var results = (funcNameRegex).exec((obj).constructor.toString());
            var returnObj = (results && results.length > 1) ? results[1] : "";
            var split = returnObj.split('_');

            return split[0];
        }

        private getDragExpressionByScope($scope): Wars.Domain.Model.Conditions.Expression {
           var expression = $scope.expression;
            return<Wars.Domain.Model.Conditions.Expression>expression;
        }

        public onDropTreeItem($event, expression: Wars.Domain.Model.Conditions.TreeItemExpression) {
            var treeItem = this.treeService.createTreeItemFromItemDropped(() => {

                expression.treeItem = treeItem;
                expression.treeItem_id = treeItem.id;

                this.setCodeGroup();

                var treeConfigItem = this.treeService.getTreeConfigurationItem();

                if (treeItem.calculation_id && treeItem.calculation.inputSchema) {
                    const paramSet = this.conditionService.createOperationParameterSet();

                    treeItem.calculation.inputSchema.properties.forEach(p => {
                        const parameter = this.conditionService.createOperationParameter(paramSet);

                        parameter.mySchemaProperty = p;
                        paramSet.operationParameters.push(parameter);
                    });

                    expression.treeItemOperationParameterSet = paramSet;
                }

                if (treeConfigItem.isList) {
                    (<any>expression).isFieldList = true;
                    this.fieldAggregateFunctionContext = this.setDropdownContext(treeItem);

                } else {
                    (<any>expression).isFieldList = false;
                    (<any>expression).aggregateFunction = null;
                }
            });
        }

        private setDropdownContext(treeItem: Wars.Domain.Model.TreeItem): any {
            switch (treeItem.variableType) {
            case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
            case Wars.Domain.Model.Codes.Enums.VariableType.Date:
            case Wars.Domain.Model.Codes.Enums.VariableType.DateTime:
            case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                return {};
            case Wars.Domain.Model.Codes.Enums.VariableType.Boolean:
            case Wars.Domain.Model.Codes.Enums.VariableType.String:
            default:
                return this.contextWithOnlyAnyAndAll;
            }
        }

        public onDropTreeItemToTreeItem($event, expression: Wars.Domain.Model.Conditions.TreeItemToTreeItemExpression) {
            var treeItem = this.treeService.createTreeItemFromItemDropped(() => {
                
                expression.valueTreeItem = treeItem;
                expression.valueTreeItem_id = treeItem.id;

                const treeConfigItem = this.treeService.getTreeConfigurationItem();

                if (treeItem.calculation_id && treeItem.calculation.inputSchema) {
                    const paramSet = this.conditionService.createOperationParameterSet();

                    treeItem.calculation.inputSchema.properties.forEach(p => {
                        paramSet.operationParameters.push(this.conditionService.createOperationParameter(paramSet));

                    });

                    expression.valueTreeItemOperationParameterSet = paramSet;
                }

                if (treeConfigItem.isList) {
                    (<any>expression).isValueFieldList = true;
                    //this.valueAggregateFunctionContext = this.setDropdownContext(treeItem);
                } else {
                    (<any>expression).isValueFieldList = false;
                    (<any>expression).valueAggregateFunction = null;
                }
            });
        }

        public onDropCalculationInput($event, operationParameter: Wars.Domain.Model.OperationParameter) {
            var treeItem = this.treeService.createTreeItemFromItemDropped(() => {
                operationParameter.treeItem = treeItem;
            });
        }

        public onDropStep($event, expression: Wars.Domain.Model.Conditions.FormStepExpression) {
            const value = ExpressionGroupModel.getDragValue();

            this.FormStepService.fetchFormStep(value.stepId)
                .then(r => {
                    expression.formStep = r;
                });
        }

        public getTreeItemParentName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';
            return this.treeService.getParentDisplayName(treeItem);
        }

        public getTreeItemIconName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';
            return this.treeService.getParentDisplayIcon(treeItem);
        }

        public getTreeItemName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';
            return this.treeService.getDisplayName(treeItem);
        }

        public useDropDown(treeItem: Wars.Domain.Model.TreeItem): boolean {
            return treeItem && treeItem.schemaProperty && treeItem.schemaProperty.codeGroup_id != null;
        }

        public removePart(expression) {
            expression.entityAspect.setDeleted();
            (<any>this.expression).parentExpression.children.remove(expression);
        }

        private setCodeGroup() {
            var treeItem = (<Wars.Domain.Model.Conditions.TreeItemToConstantExpression>this.expression).treeItem;
            if (!treeItem || !treeItem.schemaProperty || treeItem.schemaProperty.codeGroup_id == null) return;

            (<any>this.expression).codeGroupId = treeItem.schemaProperty.codeGroup_id;

            (<any>this.expression).refresh = true;
        }

    }

    export class InnerExpressionController implements IController {
        private scope: any;

        constructor(
            $scope: any,
            fieldService: services.FieldService,
            FormStepService: services.FormStepService,
            treeService: services.TreeService,
            treeItemService: services.TreeItemService,
            conditionService: services.ConditionService,
            statusAndStateService: services.StatusAndStateService,
            processConfigurationService:services.ProcessConfigurationService) {
            var expression = (<any>$scope).expression;
            $scope.model = new InnerExpressionModel(expression,
                $scope.isReadonly,
                fieldService,
                FormStepService,
                treeService,
                treeItemService,
                conditionService,
                statusAndStateService,
                $scope.processConfigurationId,processConfigurationService);
        }
    }
}

warsApp.registerDirective('InnerExpressionGroup', []);